import {CompassDirection, Justification} from './admin'

export const flexVertical = {
  '': 'center',
  n: 'start',
  ne: 'start',
  e: 'center',
  se: 'end',
  s: 'end',
  sw: 'end',
  w: 'center',
  nw: 'start',
  left: 'center',
  center: 'center',
  right: 'center',
} as const satisfies Record<
  CompassDirection | Justification,
  'start' | 'end' | 'center'
>

export const flexHorizontal = {
  '': 'center',
  n: 'center',
  ne: 'end',
  e: 'end',
  se: 'end',
  s: 'center',
  sw: 'start',
  w: 'start',
  nw: 'start',
  left: 'start',
  center: 'center',
  right: 'end',
} as const satisfies Record<
  CompassDirection | Justification,
  'start' | 'end' | 'center'
>

export const coverPos = {
  '': 'center',
  n: 'top',
  ne: 'top right',
  e: 'right',
  se: 'bottom right',
  s: 'bottom',
  sw: 'bottom left',
  w: 'left',
  nw: 'top left',
} as const satisfies Record<CompassDirection, string>
